import React from "react"
import { Input } from "antd"
const { TextArea } = Input

const contentColors = {
    dateColor: "#6B7280",
    infoColor: "#2563EB",
    errorColor: "#DC2626",
    messageColor: "#16A34A",
}

const colorizedLine = (line) => {
    if (!line) return null

    const dateText = line.slice(0, line?.indexOf("["))
    const logTypeText = line.slice(line?.indexOf("["), line?.indexOf(": ") + 1)
    const msgText = line.slice(line?.indexOf(": ") + 1)

    return (
        <div>
            <span style={{ color: contentColors.dateColor }}>{dateText}</span>
            <span style={{ color: logTypeText.includes("error") ? contentColors.errorColor : contentColors.infoColor }}>
                {logTypeText}
            </span>
            <span style={{ color: contentColors.messageColor }}>{msgText}</span>
        </div>
    )
}

const LogsContent = ({ content }) => {
    return (
        <div
            className=" col-span-5 overflow-y-auto outline-none p-4"
            style={{
                backgroundColor: "#0d1117",
                color: "#c9d1d9",
                height: "80%",
                fontFamily: "monospace",
                fontSize: "16px",
                lineHeight: "1.5",
                border: "1px solid #30363d",
                borderRadius: "6px",
                whiteSpace: "pre-wrap", // Preserve whitespace and line breaks
            }}
        >
            <div className="font-serif text-pretty" dir="ltr">
                {content !== null
                    ? content.split("\n").map((line, index) => <div key={index}>{colorizedLine(line)}</div>)
                    : "هیچ لاگی برای نمایش وجود ندارد"}
            </div>
        </div>
    )
}

export default LogsContent
